// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__A_I0M","label":"styles_label__xXoDF","spendingLimit":"styles_spendingLimit__dTQ6L"};